import i18n from "@/services/i18n";

export const appSettingsState: any = {
  state: {
    locale: process.env.VUE_APP_I18N_LOCALE || "en"
  },
  mutations: {
    SET_LOCALE(state: any, payload: any) {
      state.locale = payload;
    }
  },
  actions: {
    setLocale({ commit }: any, locale: any) {
      i18n.locale = locale;
      commit("SET_LOCALE", locale);
    }
  },
  getters: {
    locale(state: any) {
      return state.locale;
    }
  }
};
